import dayjs from 'dayjs'

export const formatDisplayDate = (date: string, format: string) =>
  dayjs.utc(date, 'YYYY-MM-DD HH:mm:ss').local().format(format)

export const formatUtcTime = (date, utc: boolean, offset) =>
  dayjs(date).utc(utc).utcOffset(offset).format('DD-MM-YYYY HH:mm:ss')
